import React from "react";
import Image from "next/image";
import { APPROACH_DATA } from "@/constastants/TailSpendConstants";
import styles from "./TailSpendManagement.module.scss";

function TailSpendApproach() {
  return (
    <div className={styles.approach}>
      <div className={styles.approachHeader}>
        <h2 className={styles.approachHeading}>
          Two Ways We Approach Tail Spend
        </h2>
        <p className={styles.approachSubtext}>
          Elchemy&apos;s first phase: Analyzing and negotiating within existing
          supplier frameworks for immediate stability. Benchmarking against
          global market pricing while avoiding new qualification costs.
        </p>
      </div>
      <div className={styles.approachCards}>
        {APPROACH_DATA.map((card) => (
          <div key={card.id} className={styles.approachCard}>
            <div className={styles.approachCardImage}>
              <Image
                src={card.image}
                alt={card.title}
                fill
                style={{ objectFit: "cover" }}
              />
            </div>
            <h3 className={styles.approachCardTitle}>{card.title}</h3>
            <p className={styles.approachCardDescription}>
              {card.description}
            </p>
            <div className={styles.approachBullets}>
              {card.bullets.map((bullet, index) => (
                <div key={index} className={styles.bulletItem}>
                  <Image
                    src={card.bulletIcon}
                    alt=""
                    width={20}
                    height={20}
                  />
                  <span>{bullet}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TailSpendApproach;
